import React, { ReactNode } from 'react';
import { Scrollbar } from '../Scrollbar/Scrollbar';

export interface IModalContentProps {
    id?: string;
    children?: ReactNode | ReactNode[];
    isScrollBarVisible?: boolean;
    isForm?: boolean;
    style?: any;
}

// const headerHeight = '80px';
// const marginBottom = '15px';

export function Content(props: IModalContentProps) {
    const { id, isScrollBarVisible, isForm, style } = props;

    return (
        <div id={`modal-content-${id}`} className="modal-content" data-testid="modal-content">
            <div
                style={{
                    ...style,
                    display: 'flex',
                }}
            >
                {(isForm && (
                    <div className="admin-form" style={{ width: '100%' }}>
                        {isScrollBarVisible ? <Scrollbar>{props.children}</Scrollbar> : props.children}
                    </div>
                )) || <>{isScrollBarVisible ? <Scrollbar>{props.children}</Scrollbar> : props.children}</>}
            </div>
        </div>
    );
}
